module.exports = __webpack_public_path__ + "img/cmbs-chronicle-aug-30-2021-group.25be2913.jpg";